import { TipoContaService } from './../../shared/service/tipo-conta.service';
import { UnidadeFederacaoService } from './../../shared/service/unidade-federacao.service';
import { RecuperacaoSenhaService } from '../../shared/service/recuperacao-senha.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TextMaskModule } from 'angular2-text-mask';
import { RecaptchaModule } from 'ng-recaptcha';

import { ConsumidorRoutingModule } from './consumidor.routing.module';
import { SharedModule } from './../../shared/shared.module';
import { SharedConsumidorModule } from './shared/consumidor-shared.module';
import { NotaFiscalService } from '../../shared/index';
import { BilheteConsumidorService } from './shared/index';
import { PremioSorteioService } from '../../shared/service/premio-sorteio.service';
import { ConsumidorLoginGovBrComponent  } from './consumidor-login-gov-br/consumidor-login-gov-br.component';

import {
  ConsumidorAdicionalComponent, ConsumidorAlterarSenhaComponent, ConsumidorComponent,
  ConsumidorCadastrarComponent, ConsumidorCartaoComponent, ConsumidorDescadastrarComponent,
  ConsumidorDetalharComponent, ConsumidorEditComponent, ConsumidorInstituicaoComponent,
  ConsumidorListComponent, ConsumidorLoginComponent, ConsumidorMsgSenhaAlteradaComponent,
  ConsumidorSenhaLogadoComponent, ConsumidorDetalheSorteioComponent, ConsumidorBilhetesComponent,
  ConsumidorVisualizarBilhetesComponent, ConsumidorNotasComponent, ConsumidorPremiosComponent,
  ConsumidorObrigadoComponent
} from './';
import { SituacaoConsumidorReferenciaSorteioService } from './shared/situacao-consumidor-referencia-sorteio.service';
import { ConsumidorDemonstrativoImpostoRendaComponent } from './consumidor-demonstrativo-imposto-renda/consumidor-demonstrativo-imposto-renda.component';
import { ConsumidorReceitaFederalService } from './shared/consumidor-receita-federal-service';
import { ConsumidorTermoLgpdComponent } from './consumidor-lgpd/consumidor-termo-lgpd';
import { ConsumidorCadastrarSenhaExternoComponent } from './consumidor-cadastrar-senha-externo/consumidor-cadastrar-senha-externo.component';

export const importExportItens = [
  ConsumidorAdicionalComponent, ConsumidorAlterarSenhaComponent, ConsumidorComponent,
  ConsumidorCadastrarComponent, ConsumidorCartaoComponent, ConsumidorDescadastrarComponent,
  ConsumidorDetalharComponent, ConsumidorEditComponent, ConsumidorInstituicaoComponent,
  ConsumidorListComponent, ConsumidorLoginComponent, ConsumidorMsgSenhaAlteradaComponent,
  ConsumidorSenhaLogadoComponent, ConsumidorDetalheSorteioComponent, ConsumidorBilhetesComponent,
  ConsumidorVisualizarBilhetesComponent, ConsumidorNotasComponent, ConsumidorPremiosComponent,
  ConsumidorObrigadoComponent, ConsumidorDemonstrativoImpostoRendaComponent, ConsumidorTermoLgpdComponent,
  ConsumidorLoginGovBrComponent, ConsumidorCadastrarSenhaExternoComponent
];

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TextMaskModule,
    RecaptchaModule.forRoot(),
    ConsumidorRoutingModule,
    SharedConsumidorModule,
    SharedModule,
    NgSelectModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [importExportItens],
  providers: [
    RecuperacaoSenhaService,
    NotaFiscalService,
    BilheteConsumidorService,
    PremioSorteioService,
    UnidadeFederacaoService,
    TipoContaService,
    SituacaoConsumidorReferenciaSorteioService,
    ConsumidorReceitaFederalService
  ],
  bootstrap: [ConsumidorComponent],
  exports: [ConsumidorRoutingModule,ConsumidorLoginGovBrComponent]
})
export class ConsumidorModule { }



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor.module.ts